<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
        @select="handleSelect"
      >
        <sidebar-item v-for="route in permission_routes" :key="route.path" :checks="checkItem" :item="route" :base-path="route.path" />
      </el-menu>
      <div style="width: 30px;height: 80px" />
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/assets/styles/variables.scss'
import {getAuditPost} from "@/api/modules/recipe";

export default {
  components: { SidebarItem, Logo },
  data(){
    return {
      checkItem:''
    }
  },
  computed: {
    ...mapGetters([
      'permission_routes',
      'sidebar',
      'storeInfo'
    ]),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    },
  },
  mounted() {
    this.data1 = window.sessionStorage.getItem('menuColor')
    getAuditPost({
      page:1,
      limit:999,
      checkStatus:0,
      storeId:this.storeInfo.storeId
    }).then(res=>{
      this.$store.dispatch('user/setRecipeNum', res.data.total)
    })
  },
  methods:{
    handleSelect(key, keyPath) {
      // if (keyPath.length === 1){
      //   this.checkItem = keyPath[0]
      // } else if (keyPath.length === 2) {
      //   this.checkItem = keyPath[0]
      // }
      this.checkItem = keyPath[0]
      window.sessionStorage.setItem('menuItem', this.checkItem )
      SidebarItem.data.data1 = ''
    }
  }
}
</script>
<style>
/*.el-menu-item.active {*/
/*  background: red !important;*/
/*  color: #42b983;*/
/*}*/
</style>
